import React from 'react';

export function renderHTML( html: string ) {
    return <span dangerouslySetInnerHTML={{__html: html}} />
}